export default __webpack_public_path__ + "static/media/lacessories1.cd766b0e.jfif";